import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../../styles/TitleLine.css";

// Section header with a "View All" link. Pass `to` (a real route, e.g.
// /learn/category/<category>) so the link is crawlable and shareable.
const TitleLine = ({ title, to }) => (
  <Container className="titleline-container">
    <Row className="titleline-row">
      <Col xs={6}>
        <h2 className="titleline-title">{title}</h2>
      </Col>
      {to && (
        <Col xs={6} className="text-end">
          <Link to={to} className="titleline-link">
            View All
          </Link>
        </Col>
      )}
    </Row>
    <Row>
      <Col className="titleline-divider-wrapper">
        <div className="titleline-divider"></div>
      </Col>
    </Row>
  </Container>
);

export default TitleLine;
